import _ from 'lodash';

import Impact from './Impact';

class Event {
  constructor(index, isWildcard, hazard, hazard_description, event_description, hint, gameover_message, icon_filename, photo_filename, c_impact, p_impact, q_impact) {
    this.index = index;
    this.isWildcard = isWildcard;
    this.hazard = hazard;
    this.hazardDescription = hazard_description;
    this.description = event_description;
    this.hint = hint;
    this.gameover_message = gameover_message;
    this.iconFilename = icon_filename;
    this.photoFilename = photo_filename;
    this.impact = new Impact(c_impact, p_impact, q_impact);
  }

  validate(col) {
    var errors = [];
    let type = this.isWildcard? 'wildcard' : 'event';
    if (!this.hazard || this.hazard.length === 0) errors.push(`Event hazard is empty in ${type} number ${col}`);
    if (!this.description || this.description.length === 0) errors.push(`Event description is empty in ${type} number ${col}`);
    if (!this.isWildcard && (!this.hint || this.hint.length === 0)) errors.push(`Event hint is empty in ${type} number ${col}`);
    if (!this.isWildcard && (!this.gameover_message || this.gameover_message.length === 0)) errors.push(`Event gameover message is empty in ${type} number ${col}`);
    if (!this.iconFilename || this.iconFilename.length === 0) {
      errors.push(`Event icon filename is empty in ${type} number ${col}`);
    } else {
      if (![".png", ".jpg"].includes(this.iconFilename.slice(-4))) errors.push(`Event icon filename is not a png or jpg in ${type} number ${col}`);
    }
    if (!this.isWildcard) {
      if (!this.hazardDescription || this.hazardDescription.length === 0) errors.push(`Hazard description is empty in ${type} number ${col}`);
      if (!this.photoFilename || this.photoFilename.length === 0) {
        errors.push(`Event photo filename is empty in ${type} number ${col}`);
      } else {
        if (![".png", ".jpg"].includes(this.photoFilename.slice(-4))) errors.push(`Event photo filename is not a png or jpg in ${type} number ${col}`);
      }
      if (this.impact.c > 0) errors.push(`Event has positive cost in ${type} number ${col}`);
      if (this.impact.p > 0) errors.push(`Event has positive preparedness in ${type} number ${col}`);
      if (this.impact.q > 0) errors.push(`Event has positive quality of life in ${type} number ${col}`);
    }
    return errors;
  }

  impactAdjustedForActions(actions) {
    let adjustedImpact = this.impact;

    actions.forEach((action) => {
      adjustedImpact = adjustedImpact.add(action.impacts[this.index]);
    });

    return adjustedImpact;
  }

  mostEffectiveActionFromActions(actions) {
    return _(actions)
      .filter((action) => { return !!action.impacts[this.index].rationale })
      .sample();
  }

  rationaleForAction(action) {
    if (action) {
      return action.impacts[this.index].rationale;
    } else {
      return null;
    }
  }
}

export default Event;



// WEBPACK FOOTER //
// ./src/models/Event.js